import React, { useEffect, useState, useCallback } from 'react';
import axios from '../setupAxios';
import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../config/api';

const BooksList = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNotice, setShowNotice] = useState(false);
  const navigate = useNavigate();

  const openNotice = useCallback(() => {
    setShowNotice(true);
  }, []);

  const closeNotice = useCallback(() => {
    setShowNotice(false);
  }, []);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const response = await axios.get(apiUrl('/api/books'), {
          headers: {},
        });
        setBooks(response.data);
      } catch (error) {
        console.error('获取数据失败:', error);
        if (error.response && error.response.status === 401) {
          navigate('/login', { state: { from: { pathname: '/product' } } });
        }
      } finally {
        setLoading(false);
      }
    };
    fetchBooks();
  }, [navigate]);

  useEffect(() => {
    if (!showNotice) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeNotice();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [showNotice, closeNotice]);

  if (loading) {
    return (
      <div className="shop-page">
        <div className="loading shop-loading">加载商品中</div>
      </div>
    );
  }

  return (
    <div className="shop-page">
      <header className="shop-header">
        <div className="shop-header__main">
          <h2 className="shop-header__title">
            <i className="fa-solid fa-store" aria-hidden="true" />
            在线商城
          </h2>
          <p className="shop-header__desc">精选 OLED 设备与配件，支持在线选购</p>
        </div>
        <div className="shop-header__meta">
          <span className="shop-header__count">
            <i className="fa-solid fa-box-open" aria-hidden="true" />
            共 {books.length} 件商品
          </span>
        </div>
      </header>

      {books.length > 0 ? (
        <div className="shop-grid">
          {books.map((book) => (
            <article key={book.id} className="shop-card">
              <div className="shop-card__media">
                <img
                  src={book.coverUrl || `https://picsum.photos/400/300?random=${book.id}`}
                  alt={book.title}
                  className="shop-card__cover"
                />
                <span className="shop-card__badge">在售</span>
              </div>

              <div className="shop-card__body">
                <h3 className="shop-card__title">{book.title}</h3>
                <p className="shop-card__spec">
                  <i className="fa-solid fa-ruler-combined" aria-hidden="true" />
                  规格：{book.author}
                </p>
                <p className="shop-card__sku">
                  <i className="fa-solid fa-barcode" aria-hidden="true" />
                  编号：{book.isbn}
                </p>

                <div className="shop-card__footer">
                  <div className="shop-card__price">
                    <span className="shop-card__price-label">单价</span>
                    <span className="shop-card__price-value">
                      <small>¥</small>
                      {book.price}
                    </span>
                  </div>

                  <div className="shop-card__actions">
                    <button
                      type="button"
                      className="shop-btn shop-btn--primary"
                      onClick={openNotice}
                    >
                      <i className="fa-solid fa-bolt" aria-hidden="true" />
                      立即购买
                    </button>
                    <button
                      type="button"
                      className="shop-btn shop-btn--cart"
                      onClick={openNotice}
                      title="加入购物车"
                      aria-label="加入购物车"
                    >
                      <i className="fa-solid fa-cart-plus" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      ) : (
        <div className="shop-empty">
          <i className="fa-solid fa-box-open shop-empty__icon" aria-hidden="true" />
          <p>暂无商品数据</p>
        </div>
      )}

      {showNotice && (
        <div
          className="shop-notice-overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="shop-notice-title"
          onClick={closeNotice}
        >
          <div className="shop-notice" onClick={(e) => e.stopPropagation()}>
            <div className="shop-notice__icon-wrap">
              <i className="fa-solid fa-circle-info shop-notice__icon" aria-hidden="true" />
            </div>
            <h4 id="shop-notice-title" className="shop-notice__title">
              温馨提示
            </h4>
            <p className="shop-notice__text">功能暂没开放</p>
            <button type="button" className="shop-btn shop-btn--primary shop-notice__btn" onClick={closeNotice}>
              我知道了
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BooksList;
